<template>
    <div class="user-agency-create">
        <data-form title="Associate User with Agency"
                   tag="user-agency-create"
                   save-button-label="Create Association"
                   :field-model="agencyUser"
                   :field-groups="fieldGroups"
                   :disabledFields="disabledFields"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/user/view/${userId}`"
                   :load-model-instance="loadModelInstance"
                   submit-success-message="User agency info created"
                   submit-error-message="Error creating association">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import AgencyUser from '@/models/AgencyUser'

export default Vue.extend({
    name: 'UserAgencyCreate',
    props: {
        userId: Number,
        agencyId: Number,
    },
    data () {
        return {
            agencyUser: AgencyUser,
            disabledFields: ['user_full_name'],
            userInfo: {},
        }
    },
    computed: {
        fieldGroups () {
            let fieldGroupLeft = ['user_full_name', 'agency_id']
            let fieldGroupRight = [
                'is_program_admin',
                'is_owners_representative',
                'is_project_manager',
                'department',
                'company_name'
            ]
            return [fieldGroupLeft, fieldGroupRight]
        },
    },
    methods: {
        loadModelInstance () {
            return this.$api.getItem(this, 'user', this.userId)
                .then((user) => {
                    return {
                        user_id: this.userId,
                        user_full_name: user.full_name
                    }
                })
        },
        onSubmit (modelInstance) {
            return this.$api.createItem(this, 'agency-user', modelInstance)
                .then(async (response) => {
                    this.$router.push(`/user/view/${this.userId}`)
                })
        }
    },
})

</script>
